import { makeStyles } from '@material-ui/core/styles';

export const baseStyles = makeStyles({
  wrapper: {
    margin: '0 0 2px 9px'
  },
  circleIcon: {
    width: '19px',
    height: '19px',
    marginRight: '5px'
  },
  labelText: {
    marginBottom: '-2px',
    fontSize: '13px'
  }
});

export const menuItemStyles = makeStyles({
  root: {
    color: '#666666',
    '&:hover': {
      color: '#000000'
    }
  }
});

export const menuListStyles = makeStyles({
  list: {
    padding: 0,
    border: '1px solid #F0F0F0',
    borderRadius: '4px',
    boxShadow: '1px 2px 15px rgba(0,0,0, 0.08)',
    minWidth: '140px'
  }
});

export const iconButtonStyles = makeStyles({
  root: {
    marginLeft: '-12px',
    fontSize: '10px',
    color: '#0E8BB4'
  }
});
